// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BehanceSquareFilledSvg from "@fishx/icons-svg/es/asn/BehanceSquareFilled";
import FishxIcon from '../components/FishxIcon';

var BehanceSquareFilled = function BehanceSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BehanceSquareFilledSvg
  }));
};

BehanceSquareFilled.displayName = 'BehanceSquareFilled';
export default React.forwardRef(BehanceSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BehanceSquareFilled.js
// module id = 2063
// module chunks = 0